import { t } from "../../../data/strings";
import type { IwTeam } from "../../../features/infinite-war";

export function topHtml(): string {
  return `
    <div class="iw-top-row">
      <button type="button" class="menu-btn iw-menu-btn" data-menu>${t("iw.menu.open")}</button>
    </div>
  `;
}

export function pauseHtml(): string {
  return `
    <div class="menu-panel iw-menu-card">
      <h2>${t("iw.menu.title")}</h2>
      <button type="button" class="menu-btn menu-btn-primary" data-resume>${t("iw.menu.resume")}</button>
      <button type="button" class="menu-btn" data-restart>${t("iw.menu.restart")}</button>
      <button type="button" class="menu-btn" data-quit>${t("iw.menu.quit")}</button>
    </div>
  `;
}

export function resultHtml(winner: IwTeam): string {
  const title =
    winner === "south" ? t("iw.win.south") : t("iw.win.north");
  return `
    <div class="menu-panel iw-menu-card">
      <h2>${title}</h2>
      <button type="button" class="menu-btn menu-btn-primary" data-restart>${t("iw.menu.restart")}</button>
      <button type="button" class="menu-btn" data-quit>${t("iw.menu.quit")}</button>
    </div>
  `;
}
